import axios from 'axios';

const DOCUMENT_SERVICE_URL = process.env.REACT_APP_DOCUMENT_SERVICE_URL || 'http://localhost:8090';

// Document-generation is exposed through the ERP edge in production. Attach the
// existing login token only to requests for this service so unrelated axios
// traffic is not modified.
axios.interceptors.request.use((config) => {
  if (!config?.url || !config.url.startsWith(DOCUMENT_SERVICE_URL)) {
    return config;
  }

  const token = window.localStorage.getItem('token');
  if (!token) {
    return config;
  }

  config.headers = config.headers || {};
  if (!config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
